export default __webpack_public_path__ + "media/images/Masto-I2-Automne-ea898c3d947cdcfa779a8763f780893a.png";